export const AUTH_TIMEOUT_MS = 10000;
